import apiRequest from "../../functions/api";

export const fetchQualificationKeys = (client, accessToken, hvktKey) => {
  return new Promise((resolve, reject) => {
    const payload = {
      mandant: client,
      program: hvktKey ? "WEBAGU" : "LTERW2",
      statement: "QUALIFIKATIONS_ABLAGENAMEN_HOLEN",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest(
      "POST",
      "daten",
      payload,
      headers,
      (response) => {
        if (response.status === 200) {
          resolve(response.data.hdokKeys);
        } else {
          if (response) {
            reject(response.data.message);
          } else {
            reject("Keine Internetverbindung");
          }
        }
        resolve();
      },
      () => {
        reject("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
      },
    );
  });
};
